// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__OYYcr","iconWrapper":"styles_iconWrapper__62KiJ","textWrapper":"styles_textWrapper__7agdc"};